import React from "react";
import "./ThreeSteps.css";

const items = [
  {
    id: "01",
    title: "OUR PROJECTS",
    icon: (
      <svg viewBox="0 0 64 64" aria-hidden="true">
        <g fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M24 12h16l2 6H22l2-6z" />
          <path d="M32 18v10" />
          <path d="M18 56l10-28h8l10 28" />
          <path d="M14 56h36" />
          <path d="M8 10v44M8 24h6M8 32h6M8 40h6M8 48h6" />
        </g>
      </svg>
    ),
    text:
      "Site development and heavy civil builds—from grading and excavation to underground utilities, stormwater, foundations, roadway/paving, and modular set support. Built to spec with documented QA/QC."
  },
  {
    id: "02",
    title: "OUR SERVICES",
    icon: (
      <svg viewBox="0 0 64 64" aria-hidden="true">
        <g fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="8" y="18" width="28" height="14" rx="3" />
          <rect x="28" y="32" width="28" height="14" rx="3" />
          <path d="M36 25v8m-8 0h8" />
          <path d="M22 18V8h8" />
          <path d="M46 56a6 6 0 006-6c0-4-6-10-6-10s-6 6-6 10a6 6 0 006 6z" />
        </g>
      </svg>
    ),
    text:
      "End-to-end delivery: preconstruction and estimating, mass grading & earthwork, utility installs (water, sewer, storm), concrete & structural packages, erosion control, and modular assembly support."
  },
  {
    id: "03",
    title: "PARTNERSHIP",
    icon: (
      <svg viewBox="0 0 64 64" aria-hidden="true">
        <g fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="8" y="10" width="18" height="26" rx="2" />
          <path d="M12 18h10M12 24h10M12 30h7" />
          <path d="M28 30l6 6a4 4 0 006 0l2-2 6 6a4 4 0 010 6 4 4 0 01-6 0l-1-1-1 1a6 6 0 01-8 0l-8-8" />
          <path d="M46 22h8l-4 12-14 14-6 2 2-6 14-14 0 0" />
        </g>
      </svg>
    ),
    text:
      "Certified DBE / MBE / SCS / SBA; signatory with Laborers & Operators; proud AGC member. We align with developers, municipalities, and GCs—prioritizing safety, quality, efficiency, and respect."
  }
];

export default function ThreeSteps() {
  return (
    <section className="steps" aria-labelledby="steps-title">
      <div className="steps__container">
        <div className="steps__intro">
    
          <h2 id="steps-title" className="steps__title">
            Shaping Infrastructure Together
          </h2>
          <p className="steps__lede">
            From sitework and utilities to structural and modular support,
            we deliver heavy civil projects with clear schedules, rigorous QA/QC,
            and a partnership mindset.
          </p>
        </div>

        <div className="steps__grid" role="list">
          {items.map((item) => (
            <article className="steps__card" role="listitem" key={item.title}>
              <div className="steps__card-inner">
                <div className="steps__icon-section">
                  <div className="steps__main-icon">
                    {item.icon}
                  </div>
                  <span className="steps__number">{item.id}</span>
                </div>

                <div className="steps__content">
                  <h3 className="steps__panel-title">
                    <span>{item.title}</span>
                  </h3>

                  <p className="steps__text">{item.text}</p>

                  <div className="steps__line"></div>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
